module.exports = __webpack_public_path__ + "assets/fe67e1f3a6b354aacf2f3b98a47a4bfd.svg";